import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AccountActivationDialogComponent } from './account-activation-dialog/account-activation-dialog.component';
import { SharedModule } from '../shared/shared.module';

@Component({
  standalone: true,
  selector: 'app-account-activation-page',
  template: '',
  imports: [SharedModule]
})
export class AccountActivationPageComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    console.log(">> ACTIVATE PAGE LOADED avec code :", this.route.snapshot.queryParamMap.get('code'));
    const code = this.route.snapshot.queryParamMap.get('code');

    this.dialog.open(AccountActivationDialogComponent, {
      data: { verificationCode: code },
      disableClose: true,
      width: '700px'
    });
  }
}
